import type { OwaDate } from '../../../schema';
import { GlobalCalendarLocale, GlobalCalendarLanguage } from '../../../intl/globalCalendarLocale';
import type { LunarDateStrings } from '../lunar/getIntlDateLunar';
import { LunarCalendarType } from '../lunar/LunarCalendarType';
import getIntlDateLunar from '../lunar/getIntlDateLunar';

const days: string[] = [
    '', // This is never used since the first day is the month name
    '初二',
    '初三',
    '初四',
    '初五',
    '初六',
    '初七',
    '初八',
    '初九',
    '初十',
    '十一',
    '十二',
    '十三',
    '十四',
    '十五',
    '十六',
    '十七',
    '十八',
    '十九',
    '二十',
    '廿一',
    '廿二',
    '廿三',
    '廿四',
    '廿五',
    '廿六',
    '廿七',
    '廿八',
    '廿九',
    '三十',
];

const monthsSimplified: string[] = [
    '正月',
    '二月',
    '三月',
    '四月',
    '五月',
    '六月',
    '七月',
    '八月',
    '九月',
    '十月',
    '十一月',
    '十二月',
];

const monthsTraditional: string[] = [
    '一月',
    '二月',
    '三月',
    '四月',
    '五月',
    '六月',
    '七月',
    '八月',
    '九月',
    '十月',
    '十一月',
    '十二月',
];

const leapMonthCharacterSimplified = '闰';
const leapMonthCharacterTraditional = '閏';

const stringsSimplified: LunarDateStrings = {
    days: days,
    months: monthsSimplified,
    leapMonthCharacter: leapMonthCharacterSimplified,
};

const stringsTraditional: LunarDateStrings = {
    days: days,
    months: monthsTraditional,
    leapMonthCharacter: leapMonthCharacterTraditional,
};

export default function getIntlDateChineseLunar(
    date: OwaDate,
    locale: GlobalCalendarLocale
): string {
    const strings =
        locale.calendarLanguage == GlobalCalendarLanguage.ChineseTraditional
            ? stringsTraditional
            : stringsSimplified;

    return getIntlDateLunar(date, LunarCalendarType.Chinese, strings);
}
